export default __webpack_public_path__ + "static/media/review_chevron_right.edd81008.svg";